// extracted by css-extract-rspack-plugin
export default {"pv":"nM7lZZsfwwFspyux","pvAws":"EqkoXrpOI_4pIr3C","pvAz":"OoKfIfYYfYD93fc_","pvGcp":"XUZ0cszX34ZbVize"};